export const GOOGLE_MAP_ADDRESS_TYPE = 'GOOGLE'
export const MASTER_DATA_ADDRESS_TYPE = 'MEP_MASTER_DATA'
